module.exports = __webpack_public_path__ + "static/media/transaction-error-icon-white.8e4fbfaf.svg";